import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { AppState } from './store/AppState';
import { SessionInfo } from './api/UserPrefs-dto';
import { BaseDirectiveObject } from './components/common/base-directive-object';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SET_USER } from './store/user';
import { SET_SESSIONREFRESH } from './store/sessionRefreshState';

@Injectable()
export class TokenService extends BaseDirectiveObject {
  private sessionInfo: SessionInfo;
  private sessionRefreshing: boolean;
  private sessionRefreshObs: Observable<boolean>;

  private jwtHelper: JwtHelperService = new JwtHelperService();
  private authHeaderName: string;


  constructor(private store: Store<AppState>) {
    super();
    this.subscribe(store.select('user'), (sesInfo: SessionInfo) => this.setSessionInfoInternal(sesInfo));
    this.sessionRefreshObs = store.select('sessionRefresh');
    this.subscribe(this.sessionRefreshObs.pipe(
      tap((sessionRefresh: any) => {
        this.sessionRefreshing = sessionRefresh === 'true' || sessionRefresh === true;
      })
    ));
  }

  public setSessionInfoInternal(sesInfo: SessionInfo) {
    this.sessionInfo = sesInfo;
    if (this.sessionInfo?.accessToken) {
      this.authHeaderName = this.jwtHelper.decodeToken(this.sessionInfo.accessToken)['authHaderName'];
    }

  }

  public getAuthHaderName(): string {
    if (this.authHeaderName === undefined) {
      this.authHeaderName = this.jwtHelper.decodeToken(this.sessionInfo.accessToken)['authHaderName'];
    }
    return this.authHeaderName;
  }

  public isSessionRefreshing(): boolean {
    return this.sessionRefreshing;
  }

  public getSessionRefreshingObservable(): Observable<boolean> {
    return this.sessionRefreshObs;
  }

  public getAccessToken(): string {
    let token = '';
    if (this.sessionInfo && this.sessionInfo.accessToken) {
      token = this.sessionInfo.accessToken;
    }
    return token;
  }

  public getRefreshToken(): string {
    let refreshtoken = '';
    if (this.sessionInfo && this.sessionInfo.refreshToken) {
      refreshtoken = this.sessionInfo.refreshToken;
    }
    return refreshtoken;
  }

  public setSessionInfo(sessionInfo: SessionInfo) {
    this.sessionInfo = sessionInfo;
    // actualizar datos de sesion en Store tras renovar token
    this.store.dispatch(SET_USER({ sessionInfo: sessionInfo }));
  }

  public setRefreshingToken(value: boolean): void {
    this.sessionRefreshing = value;
    this.store.dispatch(SET_SESSIONREFRESH({ state: value }));
  }

  public getSessionInfo(): SessionInfo {
    return this.sessionInfo;
  }

}
